module.exports = __webpack_public_path__ + "img/23.d5ecfb5d.jpg";